export const endpoints = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    me: '/auth/me',
    updateProfile: '/auth/me',
    changePassword: '/auth/me/password',
    verifyEmail: '/auth/verify-email',
    resendVerificationEmail: '/auth/resend-verification-email',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },
  cart: {
    get: '/cart',
    update: '/cart',
    clear: '/cart',
  },
  addresses: {
    list: '/addresses',
    create: '/addresses',
    update: (id: string) => `/addresses/${id}`,
    delete: (id: string) => `/addresses/${id}`,
    defaultShipping: (id: string) => `/addresses/${id}/default-shipping`,
    defaultBilling: (id: string) => `/addresses/${id}/default-billing`,
  },
  orders: {
    list: '/orders',
    create: '/orders',
    detail: (id: string) => `/orders/${id}`,
    invoice: (id: string) => `/orders/${id}/invoice`,
    cancellationRequest: (id: string) => `/orders/${id}/cancellation-request`,
    requests: (id: string) => `/orders/${id}/requests`,
    withdrawRequest: (orderId: string, requestId: string) =>
      `/orders/${orderId}/requests/${requestId}`,
  },
  admin: {
    orders: {
      list: '/admin/orders',
      updateStatus: (id: string) => `/admin/orders/${id}/status`,
      updateTracking: (id: string) => `/admin/orders/${id}/tracking`,
      cancel: (id: string) => `/admin/orders/${id}/cancel`,
      uploadInvoice: (id: string) => `/admin/orders/${id}/invoice`,
      downloadInvoice: (id: string) => `/admin/orders/${id}/invoice`,
    },
    orderRequests: {
      list: '/admin/order-requests',
      update: (id: string) => `/admin/order-requests/${id}`,
    },
    preOrders: {
      list: '/admin/pre-orders',
      update: (id: string) => `/admin/pre-orders/${id}`,
    },
  },
  checkout: {
    create: '/checkout',
  },
  payments: {
    iyzico: {
      initialize: '/payments/iyzico/initialize',
      complete: '/payments/iyzico/complete',
    },
  },
  products: {
    list: '/products',
    create: '/products',
    detail: (id: number) => `/products/${id}`,
    bySlug: (slug: string) => `/products/slug/${encodeURIComponent(slug)}`,
    update: (id: number) => `/products/${id}`,
    delete: (id: number) => `/products/${id}`,
    uploadImages: (id: number) => `/products/${id}/images`,
    deleteImage: (id: number) => `/products/${id}/images`,
  },
  blogPosts: {
    list: '/blog-posts',
    manageList: '/blog-posts/manage',
    manageDetail: (id: number) => `/blog-posts/manage/${id}`,
    bySlug: (slug: string) => `/blog-posts/slug/${encodeURIComponent(slug)}`,
    create: '/blog-posts',
    update: (id: number) => `/blog-posts/${id}`,
    delete: (id: number) => `/blog-posts/${id}`,
    uploadMedia: '/blog-posts/media',
    media: (fileName: string) => `/blog-posts/media/${encodeURIComponent(fileName)}`,
  },
  preOrders: {
    list: '/pre-orders',
    create: '/pre-orders',
  },
  coupons: {
    validate: '/coupons/validate',
  },
} as const;
